import { StateInfoCU } from "@scripts/generated/domaintables/states";

import { tagLookupC } from "./tagLookup";

export const stateLookupC = tagLookupC(StateInfoCU);
